<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="modalData.title"
        :show-close="false"
        width="350px"
        append-to-body
        :before-close="handleClose">
        <div class="date-modal-con">
            <el-form ref="form" :rules="rules" :model="formItem" label-width="0" class="pr40">
                <el-form-item label="" prop="data_range" class="label-required" style="margin-bottom: 0">
                    <el-date-picker
                        v-model="formItem.data_range"
                        type="daterange"
                        :disabled="searchLoading"
                        :clearable="false"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd"
                        style="width: 310px;">
                    </el-date-picker>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :disabled="searchLoading" :loading="submitLoading" class="action-btn ml20">确认
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/dataCenter.js';
    import dayjs from 'dayjs';

    export default {
        name: "DateModal",
        components: {},
        props: {
            modalData: {
                type: Object,
                required: true,
            },
            last:[String,Object],
            condition:{
                type: Array,
                required: true,
            },
            dimension:{
                type: Array,
                required: true,
            },
            rangeTime:{
                type: Array,
                required: true,
            },
            timeZone:{
                type:String,
            },
            platId:{
                type: [String,Number],
                required: true,
            },
            isTimeFilter:{
                required: false,
                type:Boolean,
                default:false,
            }
        },
        data() {
            let _this = this;
            return {
                dialogVisible: false,
                submitLoading: false,
                searchLoading:false,
                formItem: {
                    data_range: [],
                },
                rules: {
                    data_range: [
                        {type: 'array', required: true, message: '请选择日期', trigger: 'change'}
                    ]
                },
                pickerOptions: {
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        let dateStr = dayjs(time).format('YYYY-MM-DD');
                        if(_this.startDate===null){
                            return true;
                        }
                        if(_this.dateAllDisabled){
                            return true;
                        }
                        if( time.getTime() < dayjs(_this.startDate).valueOf()){
                            return true;
                        }
                        if( time.getTime() > dayjs(_this.endDate).valueOf()){
                            return true;
                        }
                        return (time.getTime() > new Date().getTime())||(time.getTime() > new Date(_this.last).getTime())|| _this.notHasCostDate.includes(dateStr);
                    },
                    cellClassName(time) {
                        let dateStr = dayjs(time).format('YYYY-MM-DD');
                        if(time.getTime() > new Date().getTime()){
                            return '';
                        }
                        if(_this.startDate===null){
                            return 'td-empty-date-start-modal-1';
                        }
                        if(_this.dateAllDisabled){
                            return 'td-empty-date-start-modal-1';
                        }
                        if( time.getTime() < dayjs(_this.startDate).valueOf()){
                            return 'td-empty-date-start-modal-1';
                        }
                        if( time.getTime() > dayjs(_this.endDate).valueOf()){
                            return 'td-empty-date-start-modal-1';
                        }
                        return (time.getTime() > new Date().getTime())||(time.getTime() > new Date(_this.last).getTime())|| _this.notHasCostDate.includes(dateStr)?'td-empty-date-start-modal-1':'';
                    },
                },
                dateAllDisabled:true,
                startDate:'',
                endDate:'',
                notHasCostDate:[],

            }
        },
        computed: {
            platTimeInterval(){
                if(!this.isTimeFilter) return '';
                return 'hour';
            },
            excludeConditionFields(){
                let conConditions = this.condition.filter(item=>{
                    let fieldConfig = item.config||{};
                    return fieldConfig.type==='content';
                });
                return conConditions.filter(item=>item.isExclude).map(item=>item.name);
            },
        },
        mounted(){
            $('body').on('mouseover','.td-empty-date-start-modal-1',function(e){
                let $target = $(e.target);
                $target.attr('title', '根据选择的条件该日期无开户日期');
            })
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.$emit('close',this.modalData);
                this.resetForm();
            },
            resetForm() {
                this.formItem.range_time = [];
                this.submitLoading = false;
                this.$refs['form'].resetFields();
            },
            showModal() {
                this.dialogVisible = true;
                this.getConditions();
                this.$nextTick(()=>{
                    this.resetForm();
                    this.formItem.data_range = this.modalData.dateValue;
                })
            },
            handleSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$emit('save-value',this.modalData,this.formItem.data_range,'date');
                        this.handleClose();
                    } else {
                        return false;
                    }
                });
            },
            getConditions(){
                this.searchLoading = true;

                let conditionData = {};

                this.condition.forEach(item=>{
                    let config = item.config||{};
                    if(config.type=='date_select'){
                        conditionData[item.name] = item.dateValue.join('/');
                        if(item.name=='start_date'){
                            conditionData.start_date_dimension = item.selectValue;
                        }else if(item.name=='create_date'){
                            conditionData.create_date_dimension = item.selectValue;
                        }
                    }else if(config.type=='date'){
                        conditionData[item.name] = item.dateValue.join('/');
                    }else if(config.type=='time'){
                        conditionData[item.name] = item.timeValue.join('/');
                    }else if(config.type=='select'){
                        conditionData[item.name] = item.selectValue;
                    }else{
                        if(item.name=='yy_type'){
                            conditionData.yy_type_dimension = item.selectValue;
                        }
                        conditionData[item.name] = (item.contentValue||[]).map(item=>item.id);
                    }
                });


                let apiType = 'getPlatConditions';
                if(this.platId == '1'){
                    apiType = 'getOPPOConditions';
                }else if(this.platId == '3'){
                    apiType = 'getVivoConditions';
                }else if(this.platId == '4'){
                    apiType = 'getHuaweiConditions';
                }else if(this.platId == '7'){
                    apiType = 'getMiConditions';
                }else if(this.platId == '8'){
                    apiType = 'getIQiYiConditions';
                }else if(this.platId == '9'){
                    apiType = 'getAppleConditions';
                }else if(this.platId == '10'){
                    apiType = 'getHuaweiADSConditions';
                }else if(this.platId == '11'){
                    apiType = 'getHonorConditions';
                }else if(this.platId == '37'){
                    apiType = 'getMiv4Conditions';
                }else if(this.platId == '12'){
                    apiType = 'getMiGlobalConditions';
                }

                let reqData = {
                    return_condition: this.modalData.name,
                    condition:conditionData,
                    exclude_condition_fields:this.excludeConditionFields.join(','),
                    range_time: this.rangeTime.join('/'),
                };
                if(this.platId=='9'||this.platId=='4'||!this.platId){
                    reqData.time_zone = this.timeZone;
                    /* 后端分表查询需要用到group数据，仅Apple渠道和整体 和华为渠道 */
                    reqData.group = (this.dimension||[]).map(item => {
                        let value = item.dimensionValue || {};
                        let groupVal = {
                            group_by: item.name,
                        };
                        if(value.start_date_dimension){
                            groupVal.start_date_dimension = value.start_date_dimension;
                        }
                        if(value.create_date_dimension){
                            groupVal.create_date_dimension = value.create_date_dimension;
                        }
                        if(value.yy_type_dimension){
                            groupVal.yy_type_dimension = value.yy_type_dimension;
                        }
                        return groupVal;
                    });
                }
                if(this.isTimeFilter){
                    reqData.time_interval = this.platTimeInterval;
                }

                API[apiType](reqData).then(res => {
                    this.searchLoading = false;
                    // let resData = res.data || [];
                    let resData = (res.data||{}).list||[];
                    this.dateAllDisabled = resData.all_disabled;
                    this.startDate = resData.start_date+'';
                    this.endDate = resData.end_date+'';
                    this.notHasCostDate = (resData.not_has_cost_date || []).map(item=>{
                        return dayjs(''+item).format('YYYY-MM-DD');
                    });

                }, (err) => {
                    console.log('getConditions error', err);
                    this.searchLoading = false;

                    // this.$message.error(err.info||'请求有误');
                    let errCondition = err.data || [];
                    if (errCondition.length > 0) {

                        let errStr = '';
                        errCondition.forEach(item=>{
                            errStr = errStr + `<p class="pb6"><span class="text-bold">${item.err_title}</span>${(item.err_msg||[]).join('，')}</p>`;
                        });
                        let htmlStr = `<div class="tal" style="max-height: 300px;overflow: auto;">${errStr}</div>`;

                        this.$confirm(htmlStr, '以下已选条件无权限', {
                            showCancelButton: false,
                            confirmButtonText: '我知道了',
                            type: 'error',
                            center: true,
                            dangerouslyUseHTMLString: true,
                            showClose: false,
                            distinguishCancelAndClose: true,
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                        });
                    }else{
                        this.$message.error(err.info||'请求有误');
                    }
                });
            },

        }
    }
</script>

<style lang="scss" scoped>
    .action-btn {
        /*width: 120px;*/
    }

    ::v-deep .el-dialog__body {
        padding: 20px;
    }

    ::v-deep.date-modal-con .el-date-editor.is-disabled{
        pointer-events: none;
    }

</style>
